import script from "./TheModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheModel.vue?vue&type=script&lang=ts&setup=true"

import "./TheModel.vue?vue&type=style&index=0&id=4babfb14&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4babfb14"]])

export default __exports__